module.exports = __webpack_public_path__ + "static/media/logo_transparent_cut_landscape.d2d1335a.png";